export enum MerchantContractActionType {
  SEE_MERCHANT_CONTRACT_FIELDS = 'see_merchant_contract_fields',
  SEE_MERCHANT_CONTRACT_FIELDS_FROM_CRM = 'see_merchant_contract_fields_from_crm',
  SEND_MERCHANT_CONTRACT_REMINDER = 'send_merchant_contract_reminder',
  SEND_NEW_MERCHANT_CONTRACT = 'send_new_merchant_contract',
}
